import React from 'react';

const emailField = (props) => {
	let fieldDetail = JSON.parse(props.fieldDetails);
	return (
	    <input type="email" className={fieldDetail.classname} name={props.fieldKey} placeholder={fieldDetail.placeHolder} value={fieldDetail.value}  onChange={props.changed}/>
	);
}

export default emailField;